<template>
  <div class="mainDiv">
    <div style="position: relative">
      <el-tabs v-model="activeName" @tab-click="tabChange">
        <el-tab-pane label="未考课程" name="1">
          <UnexaminedCourses />
        </el-tab-pane>
        <el-tab-pane label="已考课程" name="2">
          <CoursesTaken />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
 
import UnexaminedCourses from './unexaminedCourses.vue'
import CoursesTaken from './coursesTaken.vue'

export default {
  components: {
    UnexaminedCourses,
    CoursesTaken
  },
  data() {
    return {
      activeName: this.$route.query.tab || "1",
      type: '',
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        this.type = val.query.tab || "1"
      },
      immediate: true,
    },
  },
  created(){
    console.log('我是测试',this.type)
  },
  methods: {
    tabChange(tab) {
      if (tab.name === this.type) return
      let query = {
        tab: tab.name,
        batchId: this.batchId,
        courseId: this.courseId,
      }
      this.$router.push({
        query,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>